<template>
  <div id="app">
    <DialogLogin></DialogLogin>
    <router-view></router-view>
  </div>
</template>
<script>
import DialogLogin from "@/components/dialog_login";
import { sendUserHeartbeat } from "@/api/usermenu.js";
import {
  getToken,
  removeToken,
  getUuid,
  getIsAdmin,
  removeUuid,
  getrank,
  getroleId,
  removeschoolCode,
  removeroleId,
  getschoolId,
} from "@/utils/auth";
import { getAccount } from "@/api/login";
import { receptionistHeroInfo, getSeniorManagement } from "@/api/front";
import { menuButtonByToken } from "@/api/power";
import bus from "@/views/front/utils/bus.js";
export default {
  name: "app",
  components: {
    DialogLogin,
  },
  data() {
    return {
      isAdmin: getIsAdmin(),
      rank: getrank(),
      token: "",
      version: "", //build版本号
      intervalId: 0, //在线定时器
      // 统计需要的参数
      data: {
        userId: getUuid(),
        userType: "",
      },
    };
  },
  mounted() {
    // 测试老拔网线 只要他拔网线 就刷新页面
    window.addEventListener("offline", () => {
      // 网络由正常常到异常时触发
      location.reload();
    });
    window.addEventListener("online", () => {
      location.reload();
    });

    this.token = getToken();
    this.clear();
    //关闭浏览器
    window.addEventListener("beforeunload", () => {
      // console.log('执行了')
      // removeToken();
      // removeUuid();
      // removeschoolCode();
      // removeroleId();
      // 修改密码和ip不一致状态 如关闭本地有存储状态那么久清空缓存，以免再次打开浏览器时打开的还是严重/修改密码弹窗
      if (localStorage.defaultdata) {
        localStorage.clear();
        removeToken();
        removeUuid();
      } else if (localStorage.IPveiwdata) {
        localStorage.clear();
      }
    });
    if (process.env.MY_VERSION) {
      console.log("当前版本:" + process.env.MY_VERSION);
    }
  },
  computed: {},
  created() {
    // 默认跳概览
    localStorage.pageSize = 10;
    localStorage.appointPath = "/front/home";
    // var t = window.devicePixelRatio   // 获取下载的缩放 125% -> 1.25    150% -> 1.5
    // console.log(t)
    // if(t != 1){
    //   document.body.style.zoom =1/ t
    // }

    // 获取前台数据
    this.eduCloudReceptionistSchoolHeroSelectBySchoolId();

    // 高级管理-网站置灰
    getSeniorManagement().then((res) => {
      if (res.code === 200) {
        // 整站置灰
        if (res.data.grayWebsiteStatus === 1) {
          document.documentElement.style.cssText = "filter: grayscale(100%);";
        } else {
          document.documentElement.removeAttribute("style");
        }
      }
    });
    // 刷新重新获取按钮权限
    if (getToken()) {
      menuButtonByToken(getroleId()).then((menuButton) => {
        if (menuButton.code === 200) {
          let buttons = menuButton.data;
          localStorage.setItem("ButtonPermissions", JSON.stringify(buttons));
        }
      });
    }
  },
  methods: {
    async eduCloudReceptionistSchoolHeroSelectBySchoolId() {
      // 前台管理数据接口
      receptionistHeroInfo().then((res) => {
        const data = res.data;

        if (res.code === 200) {
          // 修改地址栏图标
          if (data.addressBarIconPath !== "") {
            document.head
              .querySelectorAll('Link[rel*="icon"]')
              .forEach(
                (el) => (el.href = window.g.BASE_API + data.addressBarIconPath)
              );
          }
          // 修改地址栏名称
          if (data.addressName !== "") {
            document.head.querySelector("title").innerHTML = data.addressName;
          }
        }
      });
    },
    // 初次登录发送统计请求
    first() {
      if (this.token !== undefined && this.isAdmin == "" && this.rank == 3) {
        this.data.userType = "1";
        sendUserHeartbeat(this.data).then((res) => {});
      } else if (this.token !== undefined && this.rank == 5) {
        this.data.userType = "2";
        sendUserHeartbeat(this.data).then((res) => {});
      } else if (this.token !== undefined && this.rank == 10) {
        this.data.userType = "6";
        sendUserHeartbeat(this.data).then((res) => {});
      }
    },
    //在线实时统计
    clear() {
      if (this.token !== undefined && this.isAdmin == "" && this.rank == 3) {
        // isAdmin 为空 并且 rank =3 是教师
        this.data.userType = "1";
        this.intervalId = setInterval(() => {
          sendUserHeartbeat(this.data).then((res) => {});
        }, 60000);
        // rank =2 是学生
      } else if (this.token !== undefined && this.rank == 5) {
        this.data.userType = "2";
        this.intervalId = setInterval(() => {
          sendUserHeartbeat(this.data).then((res) => {});
        }, 60000);
        // rank =6 是职工
      } else if (this.token !== undefined && this.rank == 10) {
        this.data.userType = "6";
        this.intervalId = setInterval(() => {
          sendUserHeartbeat(this.data).then((res) => {});
        }, 60000);
      }
    },
  },
  // 清除定时器
  destroyed() {
    clearInterval(this.intervalId);
  },
  // 监听token的变化
  watch: {
    token(val, oldval) {
      if (val !== undefined) {
        this.first();
      }
    },
  },
};
</script>
<style>
#app {
  width: 100%;
  height: 100%;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  outline: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue